import { Link } from 'gatsby'
import React, { useEffect, useState } from 'react'
import { cardDetails } from '../../utils/informations'
import ToggleSwitch from '../basic-components/toggle-switch/toggle-switch'
import './product.scss'
import { MdOpenInNew } from 'react-icons/md'
import { useNewCheckoutContext } from '../../context/checkout-context-v2'
import scrollTo from "gatsby-plugin-smoothscroll";
import { navigate } from "gatsby"
import { Insurances } from '../../utils/informations';
import Modal from '../modal/modal'
import GapInsuranceCard from '../gap-insurance-card/gap-insurance-card'
import { BsInfoCircleFill } from "react-icons/bs";


const Product = ({ props, origin, radioName, displayOnModal }) => {

    const { addToCart, deselectProduct, cart, updateCustomerDetails, selectedProducts, addProduct, changeStep, checkoutStep, checkDemandandNeeds } = useNewCheckoutContext()
    const [toggleSwitch, setToggleSwitch] = useState(true)
    const [addedToBasket, setAddedToBasket] = useState(false)
    const [readMore, setReadMore] = useState(false);
    const [cartItem, setCartItem] = useState();




    //if i close product details, i delete the product from cart
    const showMoreDetails = (origin) => {
        setToggleSwitch(!toggleSwitch)

        if (cardDetails.length !== 0) {

            deselectProduct(origin)
        }
    }

    //keep product details open if the product is in the cart
    const tier = Object.keys(props)
    const [tierButtonLabel, setTierButtonLabel] = useState(tier[0]);

    useEffect(() => {

        const cartItem = cart.find((item) => item.Origin === origin)
 
        if (cartItem) {

            setCartItem(cartItem)
            setToggleSwitch(true)
            setAddedToBasket(true)

        }
    }, [cart])

    useEffect(() => {

        if (origin == addProduct || addProduct === "Gap" && (origin === "Return to Invoice" || origin === "Finance Gap")) {

            setToggleSwitch(true)
            scrollTo(`#prod-${origin.split("")[0]}`);

        }

    }, [addProduct])

    let title;
    let description;
    let image;

    cardDetails.map((item) => {
        if (item.origin === origin) {
            title = item.title;
            description = item.description;
            image = item.image
        }
    })




    let monthKeys;
    let monthButtonDefaultValue

    if (props[tierButtonLabel] != undefined && props[tierButtonLabel] != null) {

        monthKeys = Object.keys(props[tierButtonLabel]);
        monthButtonDefaultValue = Object.values(props[tierButtonLabel][monthKeys[0]])

    }

    const [monthOfCoverButtonLabel, setMonthOfCoverButtonLabel] = useState(monthButtonDefaultValue);

    //active class
    const [activeClaimButton, setActiveClaimButton] = useState(0);
    const [activeMonthButton, setActiveMonthButton] = useState(Object.values(props[tier[0]])[0][0].PPPId);

    const [currentItem, setCurrentItem] = useState(Object.values(props[tier[0]])[0][0]);

    const handleGroupTitle = (item) => {

        setTierButtonLabel(item)
        let index = Object.keys(props[item])[0]

        setMonthOfCoverButtonLabel(Object.values(props[item][index]))

        const defaultValue = Object.values(props[item])[0][0]

        const { PPPId } = defaultValue
        setCurrentItem(defaultValue)

        setActiveMonthButton(PPPId)
        setActiveClaimButton(0)

        if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {

            window.gtag('event', 'view_item', { 'event_category': 'insurance-type', 'event-label': `${item}` });

        }
    }

    const proceedCheckout = async (preference) => {

        await addToCart(preference)

        // add the product from modal => redirect the user to checkout
        if (!window.location.pathname.includes("/checkout")) {
            changeStep(1)
            window.location.href = window.location.origin + '/checkout';
        }



        if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {

            window.gtag('event', 'add_to_cart', { 'event_category': 'ecommerce', 'event-label': `${currentItem.Title}`, 'value': `${currentItem.Price}` });

        }
    }

    const handleShowMonths = (item, groupTitle) => {

        // This groupTitle is only used when we take the products from the basket and check which products have been 
        // selected. We don't use 'tierButtonLabel' because handleGroupTitle and handleShowMonths are called in turn, 
        // not having time for the tierButtonLabel state to be updated, so we send producGroupTitle found in basket.
        //[EVR-548] Selected product from basket

        if(groupTitle){
            setMonthOfCoverButtonLabel(Object.values(props[groupTitle][item]))
            setActiveMonthButton(props[groupTitle][item][0].PPPId)
            setCurrentItem(props[groupTitle][item][0])
        }   
        else{
            setMonthOfCoverButtonLabel(Object.values(props[tierButtonLabel][item]))
            setActiveMonthButton(props[tierButtonLabel][item][0].PPPId)
            setCurrentItem(props[tierButtonLabel][item][0])     
    
        }
        

    }

    //[EVR-548] Selected product from basket - useEffect used to select items / options (claim_limit / month_cover / product group title)
                                            // [UKT-548] Selected product from basket
    useEffect(() => {

        if(cart && cart.length){

            cart.forEach(element => {
                if(element.ProducGroupTitle && element.ProducGroupTitle in props){

                    handleGroupTitle(element.ProducGroupTitle);
                    
                    if(element.claim_limit && element.claim_limit in props[element.ProducGroupTitle]){

                        handleShowMonths(element.claim_limit, element.ProducGroupTitle)
                        setActiveMonthButton(element.PPPId);
                        setCurrentItem(element);
                        setActiveClaimButton(element.claim_limit)
                        
                    }
             
                }

            });
        }

    }, [])

    //[EVR-548] Selected product from basket
    function checkIfProductExistInCart(btn, index){

        if(cart && cart.length != 0){
            
            let existInCart = cart.find(element => element.ProducGroupTitle === btn);

            if(existInCart) return true;            

        }
        if(index === 0) return true;

    }

    const routes = {
        'MBI': '/vehicle-warranty-insurance',
        "Alloy Wheel": "/alloy-insurance",
        "Cosmetic Repair": "/cosmetic-repair-insurance",
        "Tyre": "/tyre-insurance",
        "Finance Gap": "/gap-insurance",
        "Return to Invoice": "/gap-insurance",
        "Excess": '/excess-insurance'
    }

    const [openModal, setOpenModal] = useState(false);

    return (
        <div className={`product ${radioName == 0 ? 'uk-first-column' : ''}`} id={`prod-${origin.split("")[0]}`}>

            <div className='product-heading'>
                <div className="products-heading-parent">
                    <div className='left-column'>
                        <h3 className='product-title'>{title}</h3>
                        {/* <div>{description }</div> *too long we have to discuss if we need to change it or add a read more link */}

                        <div className="product-description">
                            {
                                readMore ? description : displayOnModal ? description.substring(0, 150) + "..." : description.substring(0, 80) + "..."
                            }
                        </div>

                        <span className='read-more' onClick={() => setReadMore(!readMore)}>{readMore ? <><span>Show less</span><span className="up">︽</span></> : <><span>Read more</span><span className="down">︾</span></>}</span>
                    </div>

                    {/* on the product modal, hide the toggle switch */}
                    {
                        !displayOnModal ? <ToggleSwitch value={toggleSwitch} changeState={() => showMoreDetails(origin)} /> : ""
                    }
                </div>

            </div>
            {
                toggleSwitch || displayOnModal === true ? (<>

                    <div className='options-wrapper'>
                        <div>

                            {
                                title === "GAP Insurance" ?
                                <h4 className='category-title'>Type of {title}<button className="tooltip-btn" onClick={() => setOpenModal(true)}><BsInfoCircleFill /></button></h4>
                                    :
                                    <h4 className='category-title'>Type of {title}</h4>
                            }

                            {openModal && (


                                <Modal openModal={setOpenModal}
                                    isModalOpen={openModal}
                                // data={finIDDfetchResult}
                                >
                                    <GapInsuranceCard props={Insurances} origin="Finance Gap"/>
                                </Modal>
                            )}

                            {tier.map((btn, index) => {
                                return (
                                    <div className="options-container" key={index}>

                                        <label htmlFor={btn}>
                                            <div className="checkbox-green-container">
                                                <input
                                                    className="checkbox-effect"
                                                    type="radio"
                                                    value={origin}
                                                    id={btn}
                                                    onClick={() => handleGroupTitle(btn)}
                                                    name={radioName}
                                                    defaultChecked={checkIfProductExistInCart(btn, index)}
                                                />
                                                <span class="checkmark"></span>
                                            </div>

                                        </label>
                                        <span class="option-label">{btn}</span>
                                    </div>

                                )
                            })}
                        </div>


                        <div className='options-buttons'>


                            <div>
                                <h4 className='category-title'>Claim limit</h4>
                                <div className='claim-limit-btns-container'>
                                    {
                                        props[tierButtonLabel] ? Object.keys(props[tierButtonLabel]).map((item, index) => {
                                            return <button type="button"
                                                key={index}
                                                className={ activeClaimButton == item ? 'claim-limit-btn-active' : activeClaimButton == index ? 'claim-limit-btn-active' : "claim-limit-btn"}
                                                onClick={() => handleShowMonths(item)}
                                                onMouseDown={() => setActiveClaimButton(item)}>£{Number(item).toLocaleString("en-US")}</button>
                                        }) : ""}
                                </div>

                            </div>
                            <div>
                                <h4 className='category-title'>Months of cover</h4>
                                <div className='claim-limit-btns-container'>
                                    {
                                        monthOfCoverButtonLabel.map((item, index) => {
                                            const { PPPId, months_of_cover } = item
                                            return <button key={index} type="button" id={PPPId} onMouseUp={() => setActiveMonthButton(PPPId)} onClick={() => setCurrentItem(item)}
                                                className={activeMonthButton === PPPId ? 'claim-limit-btn-active' : "claim-limit-btn"}>{months_of_cover}</button>
                                        })
                                    }
                                </div>
                            </div>


                        </div>
                    </div>
                    <div className={`proceed-to-checkout ${displayOnModal ? 'display-on-modal' : ''}`}>
                        <div className='price-parent'>
                            <div className='price'>£{currentItem.Price?.toFixed(2)}</div>
                            <div className='ipt' >Cost  inc. IPT at 12%</div>
                        </div>
                        <div className="terms-and-conditions">
                            <a href={currentItem.TC} className="TC" target='_blank' rel="noreferrer">View Policy Wording</a>
                            <a href={currentItem.KeyFacts} target='_blank' rel="noreferrer">View IPID</a>
                        </div>
                        <button onClick={() => proceedCheckout(currentItem)} className='buy-btn' disabled={selectedProducts.find(product => product.PPPId === currentItem.PPPId) ? true : false}>{selectedProducts.find(product => product.PPPId === currentItem.PPPId) ? 'In your basket' : 'Add To Basket'}</button>

                    </div>

                </>
                ) : ''
            }


        </div>
    )
}

export default Product